// extracted by mini-css-extract-plugin
export default {"wrapper":"MRgXj8wyo9whv5Q","table":"qQlwdAmdjOPxMxU","loader":"lpAcRIES2C6V34v"};